import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, onChange, interactive = false }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type={interactive ? "button" : undefined}
          disabled={!interactive}
          onClick={interactive ? () => onChange?.(n) : undefined}
          data-testid={interactive ? `star-${n}` : undefined}
          className={interactive ? "cursor-pointer transition-transform hover:scale-125" : "cursor-default"}
        >
          <Star
            size={size}
            className={n <= Math.round(value) ? "text-toxic" : "text-white/20"}
            fill={n <= Math.round(value) ? "#E2FF3D" : "transparent"}
          />
        </button>
      ))}
    </div>
  );
}
